'use client';

import { Accordion } from '@ngg/components';
import { PDFIcon } from '@ngg/icons';

import Icon from './icon';

/** @deprecated */
function FileAccordionItem({ file }: { file: string }) {
    return (
        <a href={file} target="_blank" rel="noreferrer">
            <div className="relative flex h-[140px] items-center justify-center border border-grey-150 bg-grey-100">
                <div className="absolute -right-1 top-4 bg-black p-1 text-xxs text-white">
                    PDF
                </div>
                <PDFIcon />
            </div>
        </a>
    );
}

/** @deprecated */
export default function Files({
    files,
    className,
    productFiles,
    productDataSheet,
}: {
    files: string[] | string;
    className?: string;
    productFiles: string;
    productDataSheet: string;
}) {
    if (!files) return null;
    const dataFiles = Array.isArray(files) ? files : [files];
    return (
        <Accordion
            title={productFiles}
            IconComponent={Icon}
            WrapperComponent="div"
            transitionProps={{ appear: false }}
            classNames={{
                wrapper: className,
                button: 'text-left items-center leading-4 p-4 font-medium rounded-none',
                panel: 'p-4',
            }}
            defaultOpen>
            <div className="mb-2 grid grid-cols-2 gap-2 lg:grid-cols-3">
                {dataFiles.map((file) => (
                    <FileAccordionItem file={file} key={file} />
                ))}
            </div>
            <p className="text-sm">{productDataSheet}</p>
        </Accordion>
    );
}
